var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-copy-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.66653 4.00016V2.00016C4.66653 1.63198 4.96501 1.3335 5.3332 1.3335H13.3332C13.7014 1.3335 13.9999 1.63198 13.9999 2.00016V11.3335C13.9999 11.7017 13.7014 12.0002 13.3332 12.0002H11.3332V13.9996C11.3332 14.3681 11.0333 14.6668 10.662 14.6668H2.67111C2.30039 14.6668 2 14.3704 2 13.9996L2.00173 4.66741C2.0018 4.2989 2.30176 4.00016 2.67295 4.00016H4.66653ZM3.33495 5.3335L3.33346 13.3335H9.99987V5.3335H3.33495ZM5.99987 4.00016H11.3332V10.6668H12.6665V2.66683H5.99987V4.00016Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.654c610db5dd17a80e0c45b56cda83c3.svg";
export { ForwardRef as ReactComponent };